import React, { Component, Fragment } from 'react';
import { fetchAcademicYears } from '../../Lookups/util';
import { Button, Form, Header, Icon, Loader, Popup, Segment, Table } from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';
import { toast, ToastContainer } from 'react-toastify';
import { FiltersOnStyle } from '../../Professor/ProfessorInputGrades/css';
import RegistrationLinkForm from './RegistrationLinkForm';
import SearchTableData from '../../util/SearchTableData';
import PaginationFront from '../../util/PaginationFront';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { getProgramName } from '../ExternalStudentForms/ExternalStudentInputForm';

class RegistrationLinkList extends Component {
    constructor(props, context) {
        super();
        this.state = {
            data: [],
            filteredData: [],
            results: [],
            academicYears: [],
            selectedAcademicYearId: null,

            loading: false,
            saving: false,
            error: false,
            showForm: false,
            editingRowData: null,
            deletingRowId: null,

            activePage: 1,
            postsPerPage: 20,
        };

        this.getResults = this.getResults.bind(this);
        this.handlePaginationChange = this.handlePaginationChange.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.formatDate = this.formatDate.bind(this);
        this.onCloseForm = this.onCloseForm.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.handleOpenNewTab = this.handleOpenNewTab.bind(this);
        this.handleCopyToClipboard = this.handleCopyToClipboard.bind(this);
    }

    componentDidMount() {
        this.setState({ loading: true });
        axios.all([fetchAcademicYears(), axios.get('/external-student-registration-link')])
            .then(axios.spread((academicYearsRes, linksRes) => {
                const academicYears = academicYearsRes.data
                    .sort((a, b) => b.name.localeCompare(a.name))
                    .map(el => ({
                        ...el,
                        key: el.id,
                        value: el.id,
                        text: el.name
                    }));
                const selectedAcademicYearId = academicYears.length > 0 ? academicYears[0].id : null;
                this.setState({
                    academicYears,
                    selectedAcademicYearId,
                    data: linksRes.data,
                    filteredData: this.filterDataByAcademicYear(linksRes.data, selectedAcademicYearId),
                    loading: false
                });
            }))
            .catch(err => {
                this.setState({ error: true });
            });
    }

    fetchData = () => {
        this.setState({ loading: true });
        axios.get('/external-student-registration-link')
            .then(res => {
                this.setState({
                    data: res.data,
                    loading: false,
                    filteredData: this.filterDataByAcademicYear(res.data, this.state.selectedAcademicYearId)
                });
            })
            .catch(err => {
                this.setState({ error: true });
            });
    };

    filterDataByAcademicYear = (data, academicYearId) => {
        return data.filter(el => {
            return el.academicYear && el.academicYear.id === academicYearId;
        })
            .sort((a, b) => b.id - a.id);
    };

    handleConfirmClick = () => {
        this.setState({ saving: true });
        axios.delete(`/external-student-registration-link/${this.state.deletingRowId}`)
            .then(res => {
                toast(<FormattedMessage id="externalStudent.toast.registrationLinkDeleted"/>);
                this.setState({
                    deletingRowId: null,
                    saving: false
                });
                this.fetchData();
            })
            .catch(err => {
                this.setState({ saving: false });
                toast(<FormattedMessage id="externalStudent.toast.saveError"/>);
            });
    };

    handleOpenNewTab = (code) => {
        const url = `${window.location.origin}/public/external-student-form/${code}`;
        window.open(url, '_blank');
    };

    handleCopyToClipboard = (code) => {
        const url = `${window.location.origin}/public/external-student-form/${code}`;
        navigator.clipboard.writeText(url)
            .then(() => {
                toast(<FormattedMessage id="externalStudent.toast.registrationLinkCopied"/>);
            });
    };

    getResults(results) {
        this.setState({ results });
        this.handlePaginationChange({}, { activePage: 1 });
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.filteredData;
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage });

    formatDate = (timestamp) => {
        return moment(timestamp)
            .format('D. M. YYYY.');
    };

    onCloseForm = () => {
        this.setState({
            showForm: false,
            editingRowData: null
        });
    };

    render() {
        const {
            academicYears,
            selectedAcademicYearId,
            loading,
            saving,
            error,
            editingRowData,
            deletingRowId,
            showForm
        } = this.state;


        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender()
            .slice(indexOfFirstPost, indexOfLastPost);

        const localStorageRole = localStorage.getItem('activeRole');
        const isStudentService = localStorageRole.slice(0, 10) === 'Studentska';
        const isVicedean = localStorageRole.startsWith('Prodekan za međunarodnu');
        const isInternationalCooperationService = localStorageRole === 'Služba za međunarodnu saradnju';

        return (
            <div>
                <Header as="h1">{<FormattedMessage id="externalStudent.registrationLinks"/>}</Header>
                <Segment.Group raised>
                    <Segment raised>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <Header as="h3">
                                {<FormattedMessage id="externalStudent.registrationLinksForMobilityStudents"/>}
                            </Header>
                            {isStudentService &&
                                <Button
                                    primary
                                    color="green"
                                    disabled={loading || showForm || deletingRowId || saving || error}
                                    floated="right"
                                    icon
                                    labelPosition="right"
                                    size="small"
                                    style={FiltersOnStyle}
                                    onClick={() => this.setState({
                                        showForm: true,
                                        editingRowData: null
                                    })}
                                >
                                    <Icon className="add"/>
                                    {<FormattedMessage id="externalStudent.createRegistrationLink"/>}
                                </Button>
                            }
                        </div>
                    </Segment>
                    {showForm &&
                        <RegistrationLinkForm link={editingRowData}
                                              onRefreshData={this.fetchData}
                                              onCloseForm={this.onCloseForm}/>}
                    <Segment>
                        <Form>
                            <Form.Group>
                                <Form.Field required width={4}>
                                    <label>{<FormattedMessage id="externalStudent.academicYear"/>}</label>
                                    <Form.Dropdown
                                        search
                                        options={academicYears}
                                        value={selectedAcademicYearId}
                                        selection
                                        placeholder={<FormattedMessage id="externalStudent.selectAcademicYear"/>}
                                        onChange={(e, { value }) => {
                                            this.setState({ selectedAcademicYearId: value });
                                            this.setState({ filteredData: this.filterDataByAcademicYear(this.state.data, value) });
                                        }}
                                    />
                                </Form.Field>
                            </Form.Group>
                        </Form>
                    </Segment>
                    <Segment>
                        {loading
                            ? <div style={{
                                paddingTop: '100px',
                                paddingBottom: '100px'
                            }}><Loader active inline="centered"/></div>
                            :
                            error ?
                                <Segment textAlign={'center'}>
                                    <Button basic onClick={() => this.fetchData()}>{<FormattedMessage
                                        id="externalStudent.loadAgain"/>}</Button>
                                </Segment> :
                                <Table celled>
                                    <Table.Header>
                                        <Table.HeaderCell colSpan={22}>
                                            <SearchTableData profMozilla data={this.state.filteredData}
                                                             getResults={this.getResults}
                                                             filterItem={['mobilityProgram.name']}/>
                                        </Table.HeaderCell>
                                        <Table.Row>
                                            <Table.HeaderCell colSpan={1}>{<FormattedMessage
                                                id="externalStudent.ordinalNumber"/>}</Table.HeaderCell>
                                            <Table.HeaderCell colSpan={3}>{<FormattedMessage
                                                id="externalStudent.organizationalUnit"/>}</Table.HeaderCell>
                                            <Table.HeaderCell colSpan={3}>{<FormattedMessage
                                                id="externalStudent.programName"/>}
                                                <div style={{
                                                    fontSize: '0.85em',
                                                    color: '#999'
                                                }}>{<FormattedMessage id="externalStudent.mobilityProgram"/>}</div>
                                            </Table.HeaderCell>
                                            <Table.HeaderCell colSpan={3}>{<FormattedMessage
                                                id="externalStudent.mobilityType"/>}
                                                <div style={{
                                                    fontSize: '0.85em',
                                                    color: '#999'
                                                }}>{<FormattedMessage id="externalStudent.mobilityFormat"/>}</div>
                                            </Table.HeaderCell>
                                            <Table.HeaderCell colSpan={3}>{<FormattedMessage
                                                id="externalStudent.mobilityProgramPeriod"/>}
                                                <div style={{
                                                    fontSize: '0.85em',
                                                    color: '#999'
                                                }}>{<FormattedMessage id="externalStudent.academicYear"/>}</div>
                                            </Table.HeaderCell>
                                            <Table.HeaderCell colSpan={3}>{<FormattedMessage
                                                id="externalStudent.fieldOfEducation"/>}</Table.HeaderCell>
                                            <Table.HeaderCell colSpan={2}>{<FormattedMessage
                                                id="externalStudent.validUntil"/>}</Table.HeaderCell>
                                            <Table.HeaderCell colSpan={2}>{<FormattedMessage
                                                id="externalStudent.numberOfSignedUp"/>}</Table.HeaderCell>
                                            <Table.HeaderCell colSpan={2}></Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        {currentPosts && currentPosts.length > 0
                                            ? currentPosts.map((link, index) => (
                                                <Table.Row
                                                    negative={link.expiresAt && new Date(link.expiresAt) < new Date()}
                                                    key={link.id}>
                                                    <Table.Cell verticalAlign={'middle'}
                                                                colSpan={1}>{index + 1}.</Table.Cell>
                                                    <Table.Cell verticalAlign={'middle'} colSpan={3}>
                                                        {link.organizationalUnit ? link.organizationalUnit.name : '-'}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign={'middle'} colSpan={3}>
                                                        {getProgramName(link)}
                                                        <div style={{
                                                            fontSize: '0.85em',
                                                            color: '#999'
                                                        }}>{link.mobilityProgram ? link.mobilityProgram.name : '-'}</div>
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign={'middle'} colSpan={3}>
                                                        {link.mobilityType ? link.mobilityType.name : '-'}
                                                        <div style={{
                                                            fontSize: '0.85em',
                                                            color: '#999'
                                                        }}>{link.mobilityFormat ? link.mobilityFormat.name : '-'}</div>
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign={'middle'} colSpan={3}>
                                                        {link.mobilityType ? (link.mobilityType._key === 'cycle'
                                                            ? (link.semester ? link.semester.name : '-')
                                                            : (link.nonCycleProgram && link.nonCycleProgram.dateFrom && link.nonCycleProgram.dateTo
                                                                ? `${this.formatDate(link.nonCycleProgram.dateFrom)} - ${this.formatDate(link.nonCycleProgram.dateTo)}`
                                                                : '-')) : '-'}
                                                        <div style={{
                                                            fontSize: '0.85em',
                                                            color: '#999'
                                                        }}>{link.academicYear ? link.academicYear.name : '-'}</div>
                                                    </Table.Cell>
                                                    <Table.Cell
                                                        verticalAlign={'middle'}
                                                        colSpan={3}>{link.fieldOfEducation ? `${link.fieldOfEducation.code} - ${link.fieldOfEducation.name}` : '-'}
                                                    </Table.Cell>
                                                    <Table.Cell
                                                        verticalAlign={'middle'}
                                                        colSpan={2}>{link.expiresAt ? this.formatDate(link.expiresAt) : '-'}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign={'middle'} colSpan={2}
                                                                textAlign={'center'}>
                                                        {link.studentCount || 0}
                                                    </Table.Cell>
                                                    <Table.Cell textAlign={'center'} verticalAlign={'middle'}
                                                                colSpan={2}>
                                                        {
                                                            (deletingRowId === link.id) ? (
                                                                <Fragment>
                                                                    <Popup
                                                                        content={<FormattedMessage
                                                                            id="externalStudent.delete"/>}
                                                                        position="top center"
                                                                        trigger={<Button
                                                                            circular
                                                                            icon
                                                                            size="tiny"
                                                                            color="blue"
                                                                            onClick={this.handleConfirmClick}
                                                                            disabled={saving}
                                                                            loading={saving}
                                                                        >
                                                                            <Icon name="check"/>
                                                                        </Button>}/>
                                                                    <Popup
                                                                        content={<FormattedMessage
                                                                            id="externalStudent.cancel"/>}
                                                                        position="top center"
                                                                        trigger={<Button
                                                                            basic
                                                                            circular
                                                                            icon
                                                                            size="tiny"
                                                                            color="blue"
                                                                            onClick={() => this.setState({ deletingRowId: null })}
                                                                            disabled={saving}
                                                                        >
                                                                            <Icon name="close"/>
                                                                        </Button>}/>
                                                                </Fragment>
                                                            ) : (
                                                                <Fragment>
                                                                    {!isVicedean && <Popup
                                                                        content={<FormattedMessage
                                                                            id="externalStudent.copyRegistrationLink"/>}
                                                                        position="top center"
                                                                        trigger={
                                                                            <Button
                                                                                basic
                                                                                circular
                                                                                icon
                                                                                size="tiny"
                                                                                color="orange"
                                                                                onClick={() => this.handleCopyToClipboard(link.code)}
                                                                            >
                                                                                <Icon name="copy outline"/>
                                                                            </Button>
                                                                        }
                                                                    />}
                                                                    {!isVicedean && <Popup
                                                                        content={<FormattedMessage
                                                                            id="externalStudent.openRegistrationLink"/>}
                                                                        position="top center"
                                                                        trigger={
                                                                            <Button
                                                                                basic
                                                                                circular
                                                                                icon
                                                                                size="tiny"
                                                                                color="blue"
                                                                                onClick={() => this.handleOpenNewTab(link.code)}
                                                                            >
                                                                                <Icon name="external alternate"/>
                                                                            </Button>
                                                                        }
                                                                    />}
                                                                    {(link.studentCount && link.studentCount > 0)
                                                                        ? <Fragment>
                                                                            <Popup
                                                                                content={<FormattedMessage
                                                                                    id="externalStudent.signedUpStudents"/>}
                                                                                position="top center"
                                                                                trigger={
                                                                                    <Button
                                                                                        as={Link}
                                                                                        to={{
                                                                                            pathname: '/dolazne-mobilnosti/registracijski-linkovi/prijavljeni-studenti',
                                                                                            state: { link: link }
                                                                                        }}
                                                                                        basic
                                                                                        circular
                                                                                        icon
                                                                                        size="tiny"
                                                                                        color="teal"
                                                                                    >
                                                                                        <Icon name="align justify"/>
                                                                                    </Button>
                                                                                }
                                                                            />
                                                                        </Fragment>
                                                                        : !isVicedean && <Fragment>
                                                                            <Popup
                                                                                content={<FormattedMessage
                                                                                    id="externalStudent.editRegistrationLink"/>}
                                                                                position="top center"
                                                                                trigger={<Button
                                                                                    basic
                                                                                    circular
                                                                                    icon
                                                                                    size="tiny"
                                                                                    color="green"
                                                                                    disabled={showForm || deletingRowId || isInternationalCooperationService}
                                                                                    onClick={() => this.setState({
                                                                                        showForm: true,
                                                                                        editingRowData: link
                                                                                    })}
                                                                                >
                                                                                    <Icon name="pencil"/>
                                                                                </Button>}
                                                                            />
                                                                            <Popup
                                                                                content={<FormattedMessage
                                                                                    id="externalStudent.deleteRegistrationLink"/>}
                                                                                position="top center"
                                                                                trigger={<Button
                                                                                    basic
                                                                                    circular
                                                                                    icon
                                                                                    size="tiny"
                                                                                    color="red"
                                                                                    disabled={showForm || deletingRowId || isInternationalCooperationService}
                                                                                    onClick={() => {
                                                                                        this.setState({ deletingRowId: link.id });
                                                                                    }}
                                                                                >
                                                                                    <Icon name="trash alternate"/>
                                                                                </Button>}
                                                                            />
                                                                        </Fragment>}
                                                                </Fragment>
                                                            )}
                                                    </Table.Cell>
                                                </Table.Row>
                                            ))
                                            : (
                                                <Table.Row>
                                                    <Table.Cell colSpan={21} textAlign="left">
                                                        {<FormattedMessage id="common.noDataToDisplay"/>}
                                                    </Table.Cell>
                                                </Table.Row>
                                            )
                                        }
                                    </Table.Body>
                                </Table>}
                        {currentPosts.length > 0 && !loading &&
                            <PaginationFront postsPerPage={this.state.postsPerPage}
                                             totalPosts={this.getDataToRender().length}
                                             paginate={this.handlePaginationChange}
                                             activePage={this.state.activePage}/>}
                    </Segment>
                </Segment.Group>
                <ToastContainer position="top-right" hideProgressBar={true}/>
            </div>

        );
    }
}

export default RegistrationLinkList;



// WEBPACK FOOTER //
// ./src/views/ExternalStudents/ExternalStudentRegistrationLink/RegistrationLinkList.js